import { render, staticRenderFns } from "./firstInstance.vue?vue&type=template&id=fa0b5848&scoped=true&"
import script from "./firstInstance.vue?vue&type=script&lang=tsx&"
export * from "./firstInstance.vue?vue&type=script&lang=tsx&"
import style0 from "./firstInstance.vue?vue&type=style&index=0&id=fa0b5848&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0b5848",
  null
  
)

export default component.exports